<template>
  <div class="main">
    <date></date>
    <backBtn></backBtn>
    <div class="headerTop"></div>

    <div class="activeTitle" style="margin-top: 60px">维修资金</div>

    <div class="wxzj_public">
      <div class="varies">
        <div class="item">
          <div class="icon">
            <img
              class="icon"
              src="../../assets/images/index_ico_wxzj@2x.png"
              alt=""
            />
          </div>
          <div class="info">
            <div class="info-title">交存金额</div>
            <div class="info-num">1337.36<span class="num1">万元</span></div>
          </div>
        </div>
        <div class="item">
          <div class="icon">
            <img
              class="icon"
              src="../../assets/images/index_ico_wxzj@2x.png"
              alt=""
            />
          </div>
          <div class="info">
            <div class="info-title">使用金额</div>
            <div class="info-num">0<span class="num1">元</span></div>
          </div>
        </div>
        <div class="item">
          <div class="icon">
            <img
              class="icon"
              src="../../assets/images/index_ico_wxzj@2x.png"
              alt=""
            />
          </div>
          <div class="info">
            <div class="info-title">分配利息</div>
            <div class="info-num">22.41<span class="num1">万元</span></div>
          </div>
        </div>
        <div class="item">
          <div class="icon">
            <img
              class="icon"
              src="../../assets/images/index_ico_wxzj@2x.png"
              alt=""
            />
          </div>
          <div class="info">
            <div class="info-title">资金余额</div>
            <div class="info-num">1356.01  <span class="num1">万元</span></div>
          </div>
        </div>
      </div>

      <div class="use">
        <div class="normal" @click="handlerClick(1)">
          <img
            style="
              width: 20px;
              height: 20px;
              vertical-align: middle;
              margin-right: 5px;
            "
            src="../../assets/images/ico_btn@2x.png"
            alt=""
          />
          一般使用流程
        </div>
        <div class="urgent" @click="handlerClick(2)">
          <img
            style="
              width: 20px;
              height: 20px;
              vertical-align: middle;
              margin-right: 5px;
            "
            src="../../assets/images/ico_btn@2x.png"
            alt=""
          />紧急使用流程
        </div>
      </div>
    </div>
    <!-- 图表 -->

    <div class="echarts">
      <div class="qushi">
        <div class="systemTitle">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;维修资金使用
        </div>
        <div class="line" id="line"></div>
      </div>
      <div class="fenbu">
        <div class="systemTitle">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;维修用途分布
        </div>
        <div class="bar" id="bar"></div>
      </div>
    </div>

    <!-- 使用明细 -->

    <div class="toushu">
      <div class="systemTitle" style="width: 50%">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;使用明细
      </div>
      <detailTable></detailTable>
    </div>
    <div class="toushu">
      <div class="systemTitle" style="width: 50%">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;使用投票
      </div>
      <voteTable></voteTable>
    </div>

    <el-dialog  :visible.sync="dialogVisible" width="80%">
      <div class="dialog_title">
        {{ dialogType == 1 ? "一般使用流程" : "紧急使用流程" }}
      </div>
      <div v-html="zsnr" class="zsnrcontent"></div>

      <!-- <div class="container" v-if="dialogType == 1">
        <h1>一般情形下使用维修资金，按以下程序办理：</h1>
        <p>
          一、
          现场查勘确认。住宅共用部位、共用设施设备需要维修和更新、改造时，居（村）民委员会、街道办事处（乡镇人民政府）、区（县）住房城乡建设主管部门、维修使用受益业主或者业主委员会（不少于3人）应当及时到现场查勘确认并填写书面意见。涉及电梯、消防设施设备的，属地市场监管或者消防部门应当配合现场查勘确认。
        </p>
        <p>
          二、提出使用方案。申请人根据房屋共用部位、共用设施设备现状、查勘意见及业主的意见，自行或者委托相关单位编制维修资金使用方案。使用方案应包括：施工范围、工程预算、维修施工单位的选择方式、维修资金的列支范围和分摊方式等内容。
        </p>
        <p>三、业主共同决策。</p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.&nbsp;使用方案公示与表决。使用方案拟定后由申请人组织相关业主依法表决，表决结果应当向相关业主公示，公示期不少于5日，公示期满，业主对表决结果没有异议或者异议不成立的，方可视为表决通过。支持和鼓励业主委员会或者物业服务人建立住宅共用部位、共用设施设备维修的年度修缮计划，经相关业主依法表决同意后，一个自然年期限内发生的属于年度修缮计划内且维修资金使用额度不超过使用方案限额的维修项目，可以直接申请使用维修资金，不再需要另行表决。
          业主大会也可在管理规约或者议事规则中约定，优化表决规则，提高业主使用维修资金的决策效率。
        </p>

        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.&nbsp;施工单位的选定。维修和更新、改造项目的费用预算低于5万元的，申请人可以采取谈判、磋商等简易方式选择维修单位；预算5万元以上的，申请人应当自行或者委托代理机构采取公开、公平、公正的竞选方式择优选择具有相应资质的维修单位。
        </p>
        <p>
          四、使用备案。申请人应当提交业主大会决议或者业主书面同意书等业主决策资料、维修资金使用方案、分摊明细、维修单位选定情况、表决结果、公示照片等到属地住房城乡建设主管部门办理备案。住房城乡建设部门对申报资料进行审核，符合要求的于提交之日起5个工作日内完成备案；不符合要求的应当书面提出补正补齐意见。未取得使用备案擅自维修造成事故的，其责任由相关负责人承担。
        </p>
        <p>
          五、组织施工。维修工程实行现场鉴证制度，取得备案后，由申请人、业主委员会、居（村）民委员会、相关业主或者委托的专业机构组成现场鉴证小组，对工程范围、工程数量、施工质量等进行现场核实监督，区（县）住房城乡建设主管部门予以指导。涉及电梯、消防设施设备的，属地市场监管或者消防部门应予以指导。
        </p>
        <p>
          六、首次资金拨付。申请人持审核通过的工程施工合同等有效资料向区（县）住房城乡建设主管部门申请拨付首次维修资金，维修工程合同约定中首次资金划拨原则上不得超过工程预算总金额的50%。工程预算5万元以下的需引入工程造价预算，5万元以上的需引入工程造价预算评审。
        </p>
        <p>
          七、组织验收。工程竣工后，施工单位应书面向申请人提出验收申请，在属地住房城乡建设主管部门的监督下，业主委员会或者相关业主、街道办事处（乡镇人民政府）、居（村）民委员会会同施工单位、监理单位，涉及特种设备的，市场监管、消防等相关单位共同进行现场验收并形成书面验收意见。竣工验收结果(包括竣工验收表等)应当在物业服务区域显著位置公示不少于5日。
        </p>
        <p>
          八、结算资金拨付。公示期满后，申请人持费用结算票据、竣工验收表、工程决算报告等资料向区（县）住房城乡建设主管部门申请拨付维修资金余额，符合拨付条件的应当及时拨付余款，并保留3%作为质量保证金。工程预算5万元以下的维修项目可直接委托注册造价工程师或有执业资格的造价员审核，工程预算5万元以上的维修项目由造价咨询机构出具审价报告。
        </p>
        <p>
          九、质量保修。维修（更新、改造）工程质量和质量保证条款按国家相关法律法规执行，维修施工单位对实施的工程承担质量保修责任，保修期内出现质量问题的，由施工单位及时组织维修并承担相应费用；保修期满后，施工单位凭业主审核意见等相关资料，向区（县）住房城乡建设主管部门申请拨付工程质量保证金。
        </p>
      </div>

      <div class="container" v-else>
        <h2>紧急情形下使用维修资金，按照以下程序办理：</h2>
        <p>
          一、告知。发生第十八条紧急情形时，业主委员会应当及时在物业服务区域内的显著位置，就维修资金用于紧急维修情况进行公告。尚未成立业主大会的，由街道办事处（乡镇人民政府）在物业服务区域内显著位置进行公告。
        </p>

        <p>
          二、报告。业主委员会或相关业主立即将情况书面报告物业服务区域所在街道办事处街道办事处（乡镇人民政府）、区（县）住房城乡建设主管部门。涉及电梯、消防设施设备的报告属地市场监管或者消防部门，并在物业服务区域显著位置进行公告。
        </p>

        <p>
          三、确认。物业所在地居（村）民委员会、街道办事处（乡镇人民政府）、属地住房城乡建设主管部门收到报告后应当立即实地查勘现场，涉及电梯、消防设施设备的，属地市场监管部门或者消防部门应当配合实地现场查勘，并在收到报告24小时内出具紧急维修确认说明。
        </p>
        <p>
          四、备案。紧急维修确认说明出具后，申请人持确认说明、公示公告影像资料、应急使用方案、工程预算、维修合同等立即向属地住房城乡建设主管部门申请紧急使用维修资金备案，住房城乡建设主管部门对申报资料进行审查，并于3个工作日内完成备案，并通知申请人按程序组织实施。发现不符合要求的，应当书面提出补正补齐意见。
        </p>
        <p>
          五、资金拨付。工程施工后，属地住房城乡建设主管部门应当及时划转资金。参照本办法第十七条相关规定组织验收和拨付资金，首次拨付的资金不得超过工程预算金额的
          60%。
        </p>
        <p>
          六、紧急维修公示。紧急维修工程验收后，申请人应当将下列材料在物业服务区域内显著位置公示不少于5日。
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.维修、更新、改造方案；
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.工程决算报告； <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.工程竣工验收表； <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.涉及户数和清册、分摊方案；
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.按照法律法规规定应该公示的其他材料。
        </p>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import backBtn from "../../components/back/index.vue";
import * as echarts from "echarts";
import detailTable from "../Table/detailTable.vue";
import voteTable from "../Table/voteTable.vue";
import date from "../../components/header/index.vue";
import api from "@/api/repair.js";

export default {
  name: "",
  components: { backBtn, detailTable, voteTable, date },
  data() {
    return {
      dialogVisible: false,
      zsnr: "",
      dialogType: 1,
      option: {
        legend: {
          data: ["使用金额"],
          right: "40px",
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
          ],
        },
        yAxis: {
          type: "value",
          splitLine: { show: false },
        },
        series: [
          {
            name: "使用金额",
            data:
              // [
              //   42757, 57229, 543099.14, 175077.44, 183865, 391134.1, 731313,
              //   784579,
              // ],
              [0, 0, 0, 0, 0, 0, 0, 0],
            type: "line",
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#37EBFF",
                },
                {
                  offset: 1,
                  color: "rgba(0,0,0, 0.1)",
                },
              ]),
            },
            itemStyle: {
              normal: {
                color: "#37EBFF",
              },
            },
          },
        ],
      },
      option1: {
        tooltip: {
          trigger: "item",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "1%",
          containLabel: true,
        },
        legend: [
          {
            data: ["主体承重部位", "屋面防水层", "房屋外墙"],
            bottom: "30px",
            textStyle: {
              color: "#fff",
            },
          },
          {
            data: ["楼梯踏步及扶手", "共用地面、墙面、吊顶、门窗"],
            bottom: "10px",
            textStyle: {
              color: "#fff",
            },
          },
        ],
        series: [
          {
            type: "pie",
            radius: "50%",
            data: [
              // { value: 1048, name: "主体承重部位" },
              // { value: 735, name: "屋面防水层" },
              // { value: 580, name: "房屋外墙" },
              // { value: 484, name: "楼梯踏步及扶手" },
              // { value: 300, name: "共用地面、墙面、吊顶、门窗" },
              { value: 0, name: "主体承重部位" },
              { value: 0, name: "屋面防水层" },
              { value: 0, name: "房屋外墙" },
              { value: 0, name: "楼梯踏步及扶手" },
              { value: 0, name: "共用地面、墙面、吊顶、门窗" },
            ],
            label: {
              formatter: function (pram) {
                // return "{a|" + pram.data.value + " " + pram.percent + "% }";
                return "{a|" + pram.percent + "% }";
              },
              padding: [0, -100, 20, -100], //关键代码！关键代码！关键代码！
              rich: {
                a: {
                  fontSize: 14,
                  color: "#fff",
                  fontWeight: 500,
                  lineHeight: 32,
                  align: "right",
                },
              },
            },
            labelLine: {
              normal: {
                length: 20,
                length2: 150, // 指示线宽度
                lineStyle: {
                  color: "#fff", // 指示线颜色
                },
              },
            },

            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
    };
  },
  created() {},
  mounted() {
    this.initEcharts();
    this.initBar();
  },
  methods: {
    initEcharts() {
      var chartDom = document.getElementById("line");
      var myChart = echarts.init(chartDom);
      myChart.setOption(this.option);
    },
    initBar() {
      var chartDom = document.getElementById("bar");
      var myChart = echarts.init(chartDom);
      myChart.setOption(this.option1);
    },
    handlerClick(type) {
      let zslx = type == 1 ? 7 : 8;
      api
        .getInfo({
          zslx: zslx,
        })
        .then((res) => {
          if (res.data.code == 200 && res.data.data) {
            this.dialogType = type;
            this.dialogVisible = true;
            this.zsnr = decodeURIComponent(res.data.data.zsnr);
          } else {
            this.$message.warning("暂无数据");
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.zsnrcontent {
  height: 540px;
  overflow-y: scroll;
  margin-top: 30px;
  &::-webkit-scrollbar {
    width: 1px;
  }
}
.wxzj_public {
  display: flex;
  margin-top: 40px;
  .varies {
    flex: 2.5;
    display: flex;
    flex-wrap: wrap;
    .item {
      width: 50%;
      display: flex;
      .icon {
        width: 120px;
        height: 120px;
      }
      .info {
        flex: 1;
        margin-top: 50px;
        .info-title {
          height: 24px;
          font-size: 16px;
          font-weight: 600;
          color: #ffffff;
          line-height: 24px;
        }
        .info-num {
          height: 36px;
          font-size: 24px;
          font-family: "barlownumber";
          font-weight: 600;

          color: #37ebff;
          line-height: 36px;
          .num1 {
            color: #37ebff;
            font-size: 16px;
            font-weight: 600;
          }
        }
      }
    }
  }
  .use {
    flex: 1;
    height: 182px;
    margin-top: 20px;
    border-radius: 16px;
    border: 1px solid #005070;
    padding: 20px;

    font-weight: 700;
    font-size: 18px;
    .normal {
      line-height: 55px;
      height: 55px;
      background: linear-gradient(135deg, #098ea8 0%, #1fb28d 100%);
      border-radius: 204px;
      border: 2px solid rgba(83, 255, 226, 0.6588);
      margin-top: 10px;
      text-align: center;
      cursor: pointer;
    }
    .urgent {
      height: 55px;
      line-height: 55px;
      background: linear-gradient(135deg, #3479d0 2%, #2c98bc 100%);
      border-radius: 204px 204px 204px 204px;
      opacity: 1;
      border: 2px solid #1bd9ff;
      text-align: center;
      cursor: pointer;
      margin-top: 30px;
    }
  }
}

.echarts {
  display: flex;
  margin-top: 20px;

  .qushi {
    flex: 1;
    height: 410px;
    padding: 20px;
    background: linear-gradient(
      154deg,
      rgba(0, 132, 255, 0.66) 0%,
      rgba(62, 126, 246, 0) 100%
    );
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
    border: 2px solid #70e2ee;
    // border-image: linear-gradient(
    //     136deg,
    //     rgba(111.77069842815399, 225.65026849508286, 238.30357432365417, 1),
    //     rgba(28.000000230968, 46.000001057982445, 69.00000348687172, 1),
    //     rgba(79.06289711594582, 116.98736250400543, 165.44643580913544, 1)
    //   )
    //   2 2;
  }

  .fenbu {
    flex: 1;
    height: 410px;
    padding: 20px;
    background: linear-gradient(
      154deg,
      rgba(0, 132, 255, 0.66) 0%,
      rgba(62, 126, 246, 0) 100%
    );
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
    border: 2px solid #70e2ee;
    // border-image: linear-gradient(
    //     136deg,
    //     rgba(111.77069842815399, 225.65026849508286, 238.30357432365417, 1),
    //     rgba(28.000000230968, 46.000001057982445, 69.00000348687172, 1),
    //     rgba(79.06289711594582, 116.98736250400543, 165.44643580913544, 1)
    //   )
    //   2 2;
    margin-left: 20px;
  }
}
.line {
  width: 100%;

  height: 309px;
}
.bar {
  width: 100%;

  height: 309px;
}
.toushu {
  height: 430px;
  margin-top: 20px;
  background: linear-gradient(
    154deg,
    rgba(0, 132, 255, 0.66) 0%,
    rgba(62, 126, 246, 0) 100%
  );
  border-radius: 24px;
  border: 2px solid #70e2ee;

  padding: 20px;
}

.dialog {
  // width: 800px;
  height: 800px;
  background: linear-gradient(
    154deg,
    rgba(0, 132, 255, 0.66) 0%,
    rgba(62, 126, 246, 0) 100%
  );
  border-radius: 24px 24px 24px 24px;
  opacity: 1;
  border: 2px solid #70e2ee;
}
::v-deep .el-dialog {
  height: 650px;
  background: url("../../assets/images/pop_img_bg@2x.png") no-repeat;
  background-size: 100% 100%;
  border-radius: 24px;

  color: #fff;
  position: relative;
}

::v-deep .el-dialog h1 {
  font-size: 26px;
  color: #fff;
}
::v-deep .el-dialog h2 {
  color: #fff;
}
::v-deep .el-dialog p {
  color: #fff;
  font-size: 18px;
  padding: 0 20px;
  line-height: 29px;
}
::v-deep .el-dialog__title {
  color: #fff;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
  font-size: 24px;
}

.dialog_title {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 285px;
  height: 46px;
  background: url("../../assets/images/img_titlebg@2x.png") no-repeat;
  background-size: 100% 100%;
  font-size: 24px;
  font-weight: 900;
  color: #fff;
  text-align: center;
  line-height: 46px;
}
.container {
  height: 500px;
  overflow-y: scroll;
  margin-top: 30px;
}
</style>
